import { showNotification } from '@/plugins/notification';
import { authErrorHandler } from '@/services/error/authHandler.js';

export default {
  async fetchChannelData({ commit }, id) {
    const response = await fetch(`/api/channels/${id}`);
    let data = await response.json();
    commit('setChannelData', data);
  },

  async clearChannelData({ commit }, id) {
    let data = {};
    commit('setChannelData', data);
  },

  async fetchChannelsList({ commit }, payload) {
    let params = new URLSearchParams({
      limit: '15',
      ownerType: payload.ownerType,
      ownerId: payload.ownerId,
    }).toString();

    const response = await fetch(`/api/channels?${params}`);
    let data = await response.json();
    commit('setChannelsList', data.results);
  },

  async fetchCreateChannel({ commit }, payload) {
    let response = await fetch(`/api/channels`, {
      method: 'POST',
      body: JSON.stringify({
        id: payload.id,
        channelId: payload.channelId,
        name: payload.name,
        description: payload.description,
        avatarFileId: payload.avatarFileId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setChannelData', data);
    }
    return response;
  },
};
